import { get, post } from './client.js';

export const listJobs    = ()         => get('/platform/backup/jobs');
export const getJob      = (id)       => get(`/platform/backup/jobs/${id}`);
export const getConfig   = ()         => get('/platform/backup/config');
export const triggerBackup = ()       => post('/platform/backup/trigger', {});
export const restoreFromJob = (id)    => post(`/platform/backup/jobs/${id}/restore`, {});
export const pruneOldBackups = ()     => post('/platform/backup/prune', {});

// Download URL is a direct browser link — not an API client call.
export const downloadUrl = (id)       => `/api/v1/platform/backup/jobs/${id}/download`;
